import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Switch from 'react-ios-switch'

import { Button } from 'controls'
import { colors } from 'theme'

import AppointmentStatus from './AppointmentStatus'

import info from './styles'

export default class extends PureComponent {
  static propTypes = {
    event: PropTypes.object,
    eventVisited: PropTypes.bool.isRequired,
    onChangeSaveData: PropTypes.func.isRequired
  }

  render() {
    const {
      event: {
        start,
        broker = {},
        brokerValuationData,
        status
      },
      eventVisited,
      onChangeSaveData
    } = this.props

    return (
      <div className="content">
        <h4 className="header highlight">
          {broker.firstName} {broker.lastName} {broker.secondLastName}
        </h4>

        <h4 className="header">Cita de Valuación</h4>

        <p className="label">Ubicación:</p>
        <p className="value">
          {brokerValuationData.address} <br />
        </p>

        <p className="label">Usuario:</p>
        <p className="value">
          {brokerValuationData.name}
        </p>

        <p className="label">Participantes:</p>
        {this.props.event.participants.map(p => (
          <p className="value">{p.participantEmail}</p>
        ))}
        <style jsx>{info}</style>
      </div>
    )
  }
}

